function getComponentStore(binding) {
  // Vue 3: vnode.context removed; use the component instance from the directive
  return binding.instance?.$store;
}

const Handler = {
  //shadow to brand color on focus
  //2 shadows - inner shadow - app color, outer shadow - brand color
  castShadow: function(el, store) {
    const shadow = store.getters.shadow_color ? store.getters.shadow_color["color"] : "#00ABC9";
    el.addEventListener('focus', function(event) {
      el.$prevShadow = Handler.getComputedStyle(el, "box-shadow");
      let shadow_primary = Handler.getComputedStyle(el, "background-color");
      shadow_primary = (shadow_primary == "rgba(0, 0, 0, 0)") ? "#f4f5f9" : shadow_primary; //#f4f5f9 - app modal color
      el.style['box-shadow'] = "0 0 0 2px " + shadow_primary + ", 0 0 6px 3px " + shadow;
    });
    el.addEventListener('focusout', function(event) {
      el.style['box-shadow'] = el.$prevShadow;
    });
  },
  //highlight color to brand color on focus
  castColor: function(el, store) {
    const color = store.getters.color ? store.getters.color["color"] : "#00ABC9";
    el.addEventListener('focus', function(event) {
      el.$color = Handler.getComputedStyle(el, "color");
      el.style['color'] = color;
      el.style['transform'] = "translateX(3px)";
      el.style['transition'] = "all 0.2s ease";
    });
    el.addEventListener('focusout', function(event) {
      el.style['color'] = el.$color;
      el.style['transform'] = "none";
    });
  },
  //common actions for both cast shadow and cast color
  common: function(el) {
    el.addEventListener('keydown', function(event) {
      const keyCode = event.which || event.keyCode;
      if (keyCode == 13) {
        el.click();
      }
    });
    el.tabIndex = '0';
    el.style.outline = 'none';
  },
  getComputedStyle: function(element, prop) {
    if (element.currentStyle) {
      return element.currentStyle[prop];
    } else if (window.getComputedStyle && window.getComputedStyle(element, null)) {
      return window.getComputedStyle(element, null).getPropertyValue(prop);
    } else {
      return element.style[prop];
    }
  }
};

function cbLinkSetup(el, binding) {
  const store = getComponentStore(binding);
  if (!store || ['color', 'shadow'].indexOf(binding.value) == -1) {
    return;
  }
  if (el.__cbLinkBound) return;
  el.__cbLinkBound = true;
  Handler.common(el);
  return binding.value == 'shadow' ? Handler.castShadow(el, store) : Handler.castColor(el, store);
}

export default {
  // Vue 2
  inserted: cbLinkSetup,
  // Vue 3 executes mounted, not inserted
  mounted: cbLinkSetup,
}
